"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSingleWatcher = void 0;
var react_1 = require("react");
var firestore_1 = require("firebase/firestore");
var react_redux_1 = require("react-redux");
var createErrorAction_1 = require("../actionCreators/createErrorAction");
var description = 'useSingleWatcher';
var useSingleWatcher = function (_a) {
    var getRef = _a.getRef, onUnsubscribe = _a.onUnsubscribe, onNext = _a.onNext, watcherKey = _a.watcherKey, handleError = _a.handleError;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = (0, react_1.useState)(), model = _b[0], setModel = _b[1];
    (0, react_1.useEffect)(function () {
        var ref = getRef === null || getRef === void 0 ? void 0 : getRef();
        if (ref) {
            var defaultHandleError = function (_a) {
                var code = _a.code, message = _a.message;
                dispatch((0, createErrorAction_1.createErrorAction)({
                    error: {
                        code: code,
                        message: message,
                        name: 'FirebaseError',
                    },
                    description: "".concat(description, " - ").concat(watcherKey),
                }));
            };
            var useHandleError = handleError || defaultHandleError;
            var unsubscribe_1 = (0, firestore_1.onSnapshot)(ref, function (querySnapshot) {
                var data = querySnapshot.data();
                setModel(data);
                onNext === null || onNext === void 0 ? void 0 : onNext(querySnapshot);
            }, useHandleError);
            dispatch({
                type: 'INCREMENT_WATCHER',
                description: description,
                increment: 1,
                watcherType: watcherKey,
            });
            return function () {
                unsubscribe_1 === null || unsubscribe_1 === void 0 ? void 0 : unsubscribe_1();
                dispatch({
                    type: 'INCREMENT_WATCHER',
                    description: description,
                    increment: -1,
                    watcherType: watcherKey,
                });
                onUnsubscribe === null || onUnsubscribe === void 0 ? void 0 : onUnsubscribe();
            };
        }
        return;
    }, [dispatch, getRef, onUnsubscribe, onNext, watcherKey, handleError]);
    return { model: model };
};
exports.useSingleWatcher = useSingleWatcher;
